export const CLUSTER = import.meta.env.VITE_NODE_ENV || 'dev';
